var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('iframe',{staticClass:"visual-sandbox",staticStyle:{"width":"532px","height":"132px"},attrs:{"sandbox":"allow-scripts","name":"visual-sandbox","width":"532","height":"148","src":"https://app.powerbi.com/13.0.8730.136/cvSandboxMinimal.html?plugin=Timeline1447991079100&locale=en-US&instanceId=7ca5016c-0c8a-cdfd-8bb0-68bd3e4afb5d"}})])])
}]

export { render, staticRenderFns }